import _extends from "@babel/runtime/helpers/extends";
/** @jsx jsx */

import { css, jsx } from '@emotion/react';
const overflowContainerStyles = css({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
});

/**
 * __Overflow container__
 */
const OverflowContainer = ({
  isSingleLine,
  ...props
}) =>
// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
jsx("span", _extends({
  css: isSingleLine && overflowContainerStyles
}, props));
export default OverflowContainer;